import { render } from "./InvoiceSidepanel.vue?vue&type=template&id=4083e5d1&scoped=true"
import script from "./InvoiceSidepanel.vue?vue&type=script&lang=js"
export * from "./InvoiceSidepanel.vue?vue&type=script&lang=js"

import "./InvoiceSidepanel.vue?vue&type=style&index=0&id=4083e5d1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4083e5d1"]])

export default __exports__